import { Text } from "@backstage/ui";
import type { SwaBundleStatus } from "@internal/backstage-plugin-avd-common";

import type { BundlePageDescriptor, BundleStatusMark } from "../bundle/bundleDescriptors";

import { MY_WEB_APPS_HERO, MY_WEB_APPS_NEW_PATH } from "./swaEntitlement";

/** How each web app status reads on its card and in the hero. */
export const SWA_STATUS_MARKS: Record<SwaBundleStatus, BundleStatusMark> = {
	provisioning: { label: "Setting up…", tone: "progress" },
	ready: { label: "Ready", tone: "ok" },
	deprovisioning: { label: "Deleting…", tone: "progress" },
	absent: { label: "Deleted", tone: "neutral" },
	failed: { label: "Did not finish", tone: "danger" },
};

/** My web apps' part of the bundle page: its copy. */
export const swaPageDescriptor: BundlePageDescriptor = {
	bundleType: "swa",
	noun: "web app",
	hero: MY_WEB_APPS_HERO,
	yours: { eyebrow: "Status", title: "Your web apps" },
	empty: {
		title: "Nothing set up",
		body: "You have no web apps yet. Set one up for a project to get a password-protected website with its own database.",
		setupLabel: "Set up a web app",
	},
	setup: {
		eyebrow: "Set up",
		title: "Another project?",
		body: "Each project gets its own password-protected website with a database. Setting one up takes about 20 minutes, and you'll get a notification in Backstage when it's ready.",
		label: "Set up for another project",
		href: MY_WEB_APPS_NEW_PATH,
	},
	goodToKnow: {
		title: "What is this, and what does it cost?",
		body: (
			<>
				<Text as="p">
					A web app is a website with its own database, set up for one project number in
					your own Azure subscription. Visitors are asked for a password, and you connect
					to it from Claude Code without pasting a secret.
				</Text>
				<ul>
					<li>The cost is billed to the project number you give when you set it up.</li>
					<li>
						Delete a web app when its project ends. That removes the site, the database
						and everything in them, and cannot be undone.
					</li>
					<li>
						Downloading the .env or revealing the visitor password is logged. Treat both
						as secrets.
					</li>
				</ul>
			</>
		),
	},
};
